import { render, staticRenderFns } from "./saleschannalList.vue?vue&type=template&id=4066761c&scoped=true&"
import script from "./saleschannalList.vue?vue&type=script&lang=js&"
export * from "./saleschannalList.vue?vue&type=script&lang=js&"
import style0 from "./saleschannalList.vue?vue&type=style&index=0&id=4066761c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066761c",
  null
  
)

export default component.exports